import React from 'react';
import { ExperimentContext } from './context';

export const createExperimentHook = <A>(
  id: string,
  baseline: A,
  variants: { [key: string]: A }
) => {
  if (
    typeof id === 'undefined' ||
    typeof baseline === 'undefined' ||
    typeof variants === 'undefined'
  ) {
    throw new Error(
      'createExperimentHook expects 3 arguments: id, baseline, variants'
    );
  }
  return (shouldSetAsViewed = true) => {
    const {
      selectedVariants,
      registerExperiment,
      setViewedExperiment,
      unregisterExperiment,
    } = React.useContext(ExperimentContext);

    const variantName =
      selectedVariants &&
      selectedVariants[id] &&
      selectedVariants[id].selectedVariant;

    React.useEffect(() => {
      registerExperiment({
        id,
        baseline,
        variants,
      });

      return () => unregisterExperiment(id);
    }, [registerExperiment, unregisterExperiment]);

    React.useEffect(() => {
      if (shouldSetAsViewed) {
        setViewedExperiment(
          id,
          variantName && variantName in variants ? variantName : 'baseline'
        );
      }
    }, [shouldSetAsViewed, setViewedExperiment, variantName]);

    return variantName && variantName in variants
      ? variants[variantName]
      : baseline;
  };
};
